import type { PaginatedResponse, PaginationMeta } from '@models/pagination'
import type { User } from '@models/user'
import type { UserFilters } from '@models/user'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import usersApi from './actions'
import { usersKeys } from './constants'

interface UseUsersData {
  users: User[]
  usersMap: Map<number, User>
  pagination: PaginationMeta
}

export const selectData = ({
  data,
  pagination,
}: PaginatedResponse<User>): UseUsersData => ({
  users: data,
  usersMap: new Map(data.map(user => [user.id, user])),
  pagination,
})

export const useUsers = (filters: UserFilters) => {
  const query = useQuery<PaginatedResponse<User>, AxiosError, UseUsersData>(
    usersKeys.users(filters),
    () => usersApi.getUsers(filters),
    {
      enabled: !!filters?.companyId,
      select: selectData,
    },
  )

  return query
}

export default useUsers
